/*
 * Copyright (c) 2020 Staffino, s.r.o. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Martin Komara, May 2020
 */

import React from 'react';
import { FlowBlockWarning as BlockModel } from '@staffino/model';
import { Paragraph } from '@staffino/flow-controls';

type Props = {
  block: BlockModel;
};

const WarningBlock = ({ block }: Props) => (
  <React.Fragment>
    <div
      style={{
        paddingTop: '40px',
        paddingBottom: '40px',
        width: '19rem',
        alignSelf: 'center',
      }}
    >
      <Paragraph
        textAlign="center"
        fontWeight="bold"
        fontSize="1.625rem"
        color="headline"
        lineHeight="1.2"
      >
        {block.mainText}
      </Paragraph>
      <Paragraph
        textAlign="center"
        fontSize="0.875rem"
        color="text"
        mt="1.2rem"
      >
        {block.text}
      </Paragraph>
    </div>
  </React.Fragment>
);

export default WarningBlock;
